import { GET_JOB_APPLICATION_BY_ID } from '../../endpoints';
import { JobApplication } from '../../types/jobs';
import makeAuthenticatedRequest from '../base-api';

const jobApplicationByIdQueryKey = (id: string) => ['application-by-id', id];

const getJobApplicationById = async (id: string): Promise<{
  success: boolean;
  applicant?: JobApplication;
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_JOB_APPLICATION_BY_ID(id));
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getJobApplicationById, jobApplicationByIdQueryKey };